<template>
  <div class="w-full mb-20 relative">
    <div class="mt-40 md:px-24">
      <two-column-projects v-for="category in categories" :category="category"/>
    </div>
  </div>
</template>
<script>
import TwoColumnProjects from "@/components/TwoColumnProjects";

export default {
  name: 'projects',
  components: {TwoColumnProjects},
  props: {},
  data() {
    return {}
  },

  computed: {
    categories() {
      if (!this.$route.params.category) {
        return ['residential', 'commercial']
      }

      if (this.$route.params.category === 'residential') {
        return ['residential', 'commercial']
      }

      if (this.$route.params.category === 'commercial') {
        return ['commercial', 'residential']
      }
    }
  },
  mounted() {

      this.$nextTick(()=>{
        document.scrollingElement.scrollTop = this.$store.state.savedPositions[this.$route.path + '_scroll'] || 0;
      })

  }
}
</script>
